import api from './api'

/**
 * 获取订单id
 *
 * @param {String} courseId 课程id
 */
export default async function getOrderId (courseId) {
  const { data: { orderId } } = await api.PackageEduFePay.payInfo({ courseId })
  return orderId
}
